export default "__VITE_ASSET__D9BRt$Ul__"